(() => {
  if (window.GuruSiteFooter) return;

  const instances = new WeakMap();
  const mobileQuery = window.matchMedia("(max-width: 680px)");

  const init = (root) => {
    if (!(root instanceof HTMLElement) || instances.has(root)) return;

    const controller = new AbortController();
    const { signal } = controller;
    const navigationDetails = [...root.querySelectorAll(".guru-footer-nav details")];
    const serviceToggle = root.querySelector("[data-guru-footer-service-toggle]");
    const serviceDetails = root.querySelector("[data-guru-footer-service-details]");
    const newsletterForm = root.querySelector(".guru-footer-newsletter__form");
    const newsletterInput = newsletterForm?.querySelector('input[type="email"]');
    const newsletterControl = newsletterForm?.querySelector(".guru-footer-newsletter__control");
    const newsletterMessage = newsletterForm?.querySelector(".guru-footer-newsletter__message");
    const newsletterInvalidEmail = newsletterForm?.dataset.invalidEmailMessage
      || "Indtast en gyldig e-mailadresse.";

    root.classList.add("is-enhanced");
    if (serviceToggle instanceof HTMLButtonElement) serviceToggle.hidden = false;

    const setService = (open) => {
      if (!(serviceToggle instanceof HTMLButtonElement) || !(serviceDetails instanceof HTMLElement)) return;
      serviceToggle.setAttribute("aria-expanded", String(open));
      serviceDetails.hidden = !open;
    };

    const syncResponsiveState = () => {
      navigationDetails.forEach((details) => {
        const summary = details.querySelector(":scope > summary");
        if (summary instanceof HTMLElement) summary.tabIndex = mobileQuery.matches ? 0 : -1;
        details.open = !mobileQuery.matches;
      });

      if (mobileQuery.matches) {
        setService(false);
      } else {
        setService(true);
      }
    };

    navigationDetails.forEach((details) => {
      details.addEventListener("toggle", () => {
        if (!mobileQuery.matches && !details.open) details.open = true;
      }, { signal });
    });

    serviceToggle?.addEventListener("click", () => {
      if (!mobileQuery.matches) return;
      setService(serviceToggle.getAttribute("aria-expanded") !== "true");
    }, { signal });

    if (newsletterForm instanceof HTMLFormElement && newsletterInput instanceof HTMLInputElement) {
      newsletterForm.noValidate = true;

      const clearNewsletterError = () => {
        newsletterControl?.classList.remove("has-error");
        newsletterInput.removeAttribute("aria-invalid");
        if (newsletterMessage instanceof HTMLElement) newsletterMessage.textContent = "";
      };

      newsletterForm.addEventListener("submit", (event) => {
        if (newsletterInput.validity.valid) {
          clearNewsletterError();
          return;
        }

        event.preventDefault();
        newsletterControl?.classList.add("has-error");
        newsletterInput.setAttribute("aria-invalid", "true");
        if (newsletterMessage instanceof HTMLElement) newsletterMessage.textContent = newsletterInvalidEmail;
        newsletterInput.focus({ preventScroll: true });
      }, { signal });

      newsletterInput.addEventListener("input", () => {
        if (newsletterInput.getAttribute("aria-invalid") === "true") clearNewsletterError();
      }, { signal });
    }

    const onMediaChange = () => syncResponsiveState();
    mobileQuery.addEventListener("change", onMediaChange);

    const onBlockSelect = (event) => {
      if (!(event.target instanceof Element) || !root.contains(event.target)) return;
      event.target.closest("details")?.setAttribute("open", "");
      if (event.target.closest("[data-guru-footer-service-details]")) setService(true);
    };
    document.addEventListener("shopify:block:select", onBlockSelect, { signal });

    syncResponsiveState();

    instances.set(root, () => {
      controller.abort();
      mobileQuery.removeEventListener("change", onMediaChange);
      root.classList.remove("is-enhanced");
      navigationDetails.forEach((details) => {
        details.open = true;
        const summary = details.querySelector(":scope > summary");
        if (summary instanceof HTMLElement) summary.tabIndex = -1;
      });
      if (serviceToggle instanceof HTMLButtonElement) {
        serviceToggle.hidden = true;
        serviceToggle.setAttribute("aria-expanded", "false");
      }
      if (serviceDetails instanceof HTMLElement) serviceDetails.hidden = false;
      if (newsletterForm instanceof HTMLFormElement) newsletterForm.noValidate = false;
      instances.delete(root);
    });
  };

  const destroy = (root) => {
    instances.get(root)?.();
  };

  const initWithin = (container = document) => {
    if (container instanceof Element && container.matches("[data-guru-site-footer]")) init(container);
    container.querySelectorAll?.("[data-guru-site-footer]").forEach(init);
  };

  document.addEventListener("shopify:section:load", (event) => initWithin(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.matches("[data-guru-site-footer]")
      ? event.target
      : event.target.querySelector("[data-guru-site-footer]");
    if (root) destroy(root);
  });

  window.GuruSiteFooter = { init: initWithin, destroy };
  initWithin();
})();
